/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_i4_105_52 as Componente_i4_105_52,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_U2 as U2,
} from "../../runtime/index.jsx";
export function Componente_r4_114_52(e) {
  let t = (0, ReactCompiler.c)(3),
    { className: n } = e,
    r = `flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-(--text) ${n === void 0 ? `` : n}`,
    i;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((i = U2.map(Componente_i4_105_52)), (t[0] = i))
    : (i = t[0]);
  let a;
  return (
    t[1] === r
      ? (a = t[2])
      : ((a = <ul aria-label={`Cultivo`} className={r} children={i} />),
        (t[1] = r),
        (t[2] = a)),
    a
  );
}
